<template>
  <div class="parkConfig">
    <div class="rule-form">
      <el-form ref="pointsRuleForm" :model="pointsRuleForm" hide-required-asterisk label-width="100px">
        <div class="deduction-rule-box">
          <el-form-item label="是否开启积分抵扣" prop="limitType"  label-width="130px">
             <el-radio-group v-model="pointsRuleForm.disable" v-if="isEdit">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            <span v-if="!isEdit" class="input-remark">{{pointsRuleForm.disable!='1'?'是':'否'}}</span>
          </el-form-item>
        </div>
        <div class="deduction-rule-box" v-if="pointsRuleForm.disable==0">
          <el-form-item label="积分抵扣规则" prop="pointStep" :rules="[{ required: true, message: '积分抵扣规则不能为空'}]">
            <el-input v-if="isEdit" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="pointsRuleForm.pointStep" class="input" >
              <template slot="append">积分</template>
            </el-input>
            <span v-if="isEdit"  class="input-remark mr10">抵扣</span>
            <span v-if="!isEdit" class="input-remark">{{ pointsRuleForm.pointStep ? pointsRuleForm.pointStep : '0'}} 积分抵扣 {{ pointsRuleForm.amountStep ? pointsRuleForm.amountStep : '0'}} 元</span>
          </el-form-item>
          <el-form-item  label="" label-width="0px" prop="amountStep" :rules="[{ required: true, message: '抵扣金额不能为空'}]">
            <el-input v-if="isEdit" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="pointsRuleForm.amountStep" class="input" >
              <template v-if="isEdit" slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="deduction-rule-box"  v-if="pointsRuleForm.disable==0">
          <el-form-item label="抵扣上限" prop="limitType">
             <el-radio-group v-model="pointsRuleForm.limitType"  v-if="isEdit">
                <el-radio label="EachDay">单日上限</el-radio>
                <el-radio label="EachOrder">单笔上限</el-radio>
              </el-radio-group>
            <span v-if="!isEdit" class="input-remark">{{pointsRuleForm.limitType=='EachDay'?'单日上限':'单笔上限'}}</span>
          </el-form-item>
        </div>
        <div v-for="(item, index) in pointsRuleForm.pointLevels" :key="index" >
          <el-form-item :label="item.name" v-if="pointsRuleForm.disable==0">
            <el-input v-if="isEdit" v-model="item.point" :disabled="true" class="input" >
              <template slot="prepend"><div class="addBtn" @click="integralAdd(item.levelId)">+</div></template>
              <template slot="append"><div  class="addBtn" @click="integralSubtract(item.levelId)">-</div></template>
            </el-input>
            <span v-if="!isEdit" class="input-remark">{{ item.point==undefined? '': item.point===0? 0 : item.point}} </span> 
            <span :class="isEdit?'input-remark':''">积分</span>
            <span class="text">{{item.point>0?`（抵扣${item.pointAmount}元）`:item.point===''?'（抵扣无上限）': `（不抵扣）`}}</span>
          </el-form-item>
        </div>
      </el-form>
    </div>
   <div class="footer">
       <el-button v-if="isEdit"  @click="onBack"  class="fun-btn mr20">取消</el-button>
       <auth-button auth="parking:point:config:edit">
        <el-button v-if="!isEdit" :loading="submitLoading" type="primary" @click="()=>{isEdit=true}" class="fun-btn" >编辑</el-button>
      </auth-button>
      <el-button v-if="isEdit" :loading="submitLoading" type="primary" @click="onSavePointsRule" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import {api_getParkingPointDetail,api_putParkingPointDetail } from '@/api/parking'
export default {
  name: "parkConfig",
  components: {
    AuthButton,
  },
  props: {
    mallId: {
      type: String,
    },
  },
  data() {
    return {
      isEdit: false,
      mallOption: [],
      pointsRuleForm: {
        pointStep: '',
        amountStep: '',
        disable:1,
        pointLevels: [],
        mallId: '',
      },
      mallIds:'',
      submitLoading: false,
      isSaveDefault:false
    };
  },
  created() {
    this.getDefaultRule()
    this.isEdit = false
    this.mallIds = this.mallId
  },
  methods: {
    // 积分会员详情
    async getDefaultRule () {
      const data = await api_getParkingPointDetail({mallId: this.mallIds})
      this.pointsRuleForm = data
      this.pointsRuleForm.disable = data.disable?1:0
      this.pointsRuleForm.limitType = data.limitType?data.limitType:'EachDay'
      this.pointsRuleForm.pointLevels =  data.pointLevels.map((item)=>{
         item.point = item.point!=undefined?item.point:''
         item.multiple = item.point!=''?item.point/data.pointStep:0
         item.pointAmount = item.multiple*data.amountStep
         return item
      })    
    },
    onSavePointsRule() {
      this.$refs.pointsRuleForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {...this.pointsRuleForm}
          params.disable==0?params.disable = false: params.disable = true
          params.mallId = this.mallIds
          try {
            await api_putParkingPointDetail(params)
            this.$baseMessage('保存成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch (error) {
            this.submitLoading = false
          }
        } else {
          return false
        }
      })
    },   
    // 返回
    onBack() {
      this.getDefaultRule()
      this.isEdit = false
      this.$forceUpdate()
    },
    // 加积分
    integralAdd(id){
      this.pointsRuleForm.pointLevels.map((item)=>{
        if(id == item.levelId){
          switch (item.point) {
            case '':
             item.point = 0
             item.multiple = 0
             item.pointAmount = 0
            break;
            default:
             item.multiple++ 
             item.point = item.multiple*this.pointsRuleForm.pointStep
             item.pointAmount = item.multiple * this.pointsRuleForm.amountStep
              break;
          }
            console.log(item)
        }
      
        return item
      })
     this.$forceUpdate()
    },
    //减积分
    integralSubtract(id){
       this.pointsRuleForm.pointLevels.map((item)=>{
         if(id == item.levelId){
          switch (item.point) {
            case 0:
             item.point = ''
            break;
            case '':
             item.point = ''
            break;
            default:
             item.multiple--
             item.point = item.multiple*this.pointsRuleForm.pointStep
             item.pointAmount = item.multiple * this.pointsRuleForm.amountStep
            break;
          }
        }
      })
       this.$forceUpdate()
    }
  },
  watch: {
      mallId: {
        immediate: true,
        handler(value,old) {
          this.mallIds = value
          this.getDefaultRule()
        }
      },
      'pointsRuleForm.pointStep':{
      handler(newVal,oldVal){
          this.pointsRuleForm.pointLevels.map(item=>{
            item.point = ''
            item.multiple = 0
            item.pointAmount = 0
           })
           this.$forceUpdate()
	    }
      },
      'pointsRuleForm.amountStep':{
      handler(newVal,oldVal){
          this.pointsRuleForm.pointLevels.map(item=>{
            item.point = ''
            item.multiple = 0
            item.pointAmount = 0
        }) 
        this.$forceUpdate()
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.parkConfig {
  width: 100%;
  margin-top:35px;
  padding: 35px 20px;
  padding-top: 0;
  padding-bottom: 74px;
  box-sizing: border-box;
  .divider1 {
    margin: 0;
    margin-top: 28px;
  }
  .divider2 {
    margin: 0;
  }
  .el-input,
  .el-textarea,
  .el-select {
    width: 250px;
  }
  .title {
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 25px;

    .btn.el-button {
      color: #1A5CF5;
      margin-left: 10px;
    }
  }

  .rule-form {
    margin-top: 20px;
    .el-textarea{
      width: 350px;
    }
    .el-input {
      width: 250px;
    }

    .input-remark {
      font-size: 14px;
      color: #333333;
      margin-left: 10px;
    }

    .hint-remark {
      font-size: 12px;
      display: inline-block;
      position: relative;
      width: 400px;
      height: 34px;
      color: #666666;
      .text {
        height: 17px;
        line-height: 17px;
        position: absolute;
        left: 0;
        bottom: 8px;
      }
    }

    .deduction-rule-box {
      display: flex;
    }
  }

  .shop-rule-box {
    margin-top: 20px;

    .fun-btn-box {
      margin: 20px 0;
    }
  }

  .add-rule-dialog {
    padding-top: 20px;
    position: relative;
    .dialog-footer {
      text-align: right;
    }
    ::v-deep{
      .el-select{
        width: 100%;
      }
      .el-form-item{
        &.notes {
          margin-bottom: 32px;
          .el-form-item__content {
            &::before {
              position: absolute;
              left: 0;
              bottom: -22px;
              content: '( 填写“0”表示永久有效 )';
              width: 140px;
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              color: #666666;
            }
            .el-form-item__error {
              height: 17px;
              left: 140px;
              padding-top: 7px;
            }
          }
        }
      }
    }
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .true{
    background: #F74A4A;
  }
  .false{
    background: #05c8af;
  }
  .picUrl{
    width: 150px;
    height: 150px;
    display: inline-block;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
  .lookTextArea{
    width: 400px;
    height: 200px;
    background: #F2F3F5;
    border-radius: 2px;
    overflow: auto;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
  }
  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
  .addBtn{
    cursor:pointer;
  }
}
</style>